export const GET_FISCAL_DATA = 'GET_FISCAL_DATA';
export const ADD_FISCAL_DATA = 'ADD_FISCAL_DATA';
export const EDIT_FISCAL_DATA = 'EDIT_FISCAL_DATA';
export const UPDATED_DOCUMENT_NUMBER = 'UPDATED_DOCUMENT_NUMBER';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
